import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af77b82"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "uq-preloader"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader loader--3" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "patient-file-container pt-16"
}
const _hoisted_5 = { class: "mb-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-expand-right me-12",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = { class: "patient-resume mb-32" }
const _hoisted_8 = { class: "p-24" }
const _hoisted_9 = { class: "patient-header d-flex flex-column flex-lg-row justify-content-between align-items-start align-items-lg-end mb-32" }
const _hoisted_10 = { class: "h4 text-primary mb-12 mb-lg-0 me-xl-16" }
const _hoisted_11 = { class: "fw-normal" }
const _hoisted_12 = { class: "d-flex" }
const _hoisted_13 = { class: "patient-data" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-6 col-lg-4 col-xl-3 mb-16" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_20 = { class: "col-6 col-lg-3 col-xl-3 mb-16" }
const _hoisted_21 = { class: "fw-bold mb-0" }
const _hoisted_22 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_23 = ["href", "aria-label", "title"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light fw-bold me-8",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_27 = { class: "col col-lg-2 col-xl-2 mb-16" }
const _hoisted_28 = { class: "fw-bold mb-0" }
const _hoisted_29 = { class: "fw-normal" }
const _hoisted_30 = { class: "col col-lg-3 col-xl-2 mb-16" }
const _hoisted_31 = { class: "fw-bold mb-0" }
const _hoisted_32 = { class: "fw-normal" }
const _hoisted_33 = { class: "col col-lg-4 col-xl-2 mb-16" }
const _hoisted_34 = { class: "d-flex align-items-center" }
const _hoisted_35 = { class: "fw-bold me-4" }
const _hoisted_36 = {
  key: 0,
  class: "fw-normal"
}
const _hoisted_37 = {
  key: 1,
  class: "fw-normal"
}
const _hoisted_38 = { class: "patient-tabs" }
const _hoisted_39 = { class: "nav nav-tabs nav-justified" }
const _hoisted_40 = { class: "nav-item" }
const _hoisted_41 = ["aria-label"]
const _hoisted_42 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_43 = ["aria-label"]
const _hoisted_44 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_45 = ["aria-label"]
const _hoisted_46 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_47 = ["aria-label"]
const _hoisted_48 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_49 = ["aria-label"]
const _hoisted_50 = {
  class: "tab-content py-3",
  id: "myTabContent"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_protocol_name = _resolveComponent("v-protocol-name")!
  const _component_the_patient_expedient_file_general = _resolveComponent("the-patient-expedient-file-general")!
  const _component_the_professional_expedient_file_medical_data = _resolveComponent("the-professional-expedient-file-medical-data")!
  const _component_the_patient_consultation = _resolveComponent("the-patient-consultation")!
  const _component_the_patient_purchase_authorization_list = _resolveComponent("the-patient-purchase-authorization-list")!
  const _component_the_patient_document = _resolveComponent("the-patient-document")!
  const _component_the_patient_personal_data_modal = _resolveComponent("the-patient-personal-data-modal")!
  const _component_the_patient_video_call_overlay = _resolveComponent("the-patient-video-call-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.status === 'loading')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.currentExpedient && _ctx.currentExpedient.patient
  && _ctx.status === 'loaded')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              class: "btn btn-link-primary btn-sm ps-0",
              to: {name: 'professional.expedient.index'},
              "aria-label": _ctx.$t('Volver')
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Volver')), 1)
              ]),
              _: 1
            }, 8, ["to", "aria-label"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h2", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.$t('Tu médico es:')) + " ", 1),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentExpedient.professional.name) + " " + _toDisplayString(_ctx.currentExpedient.professional.surname), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.can('patient.expedient.show'))
                    ? (_openBlock(), _createBlock(_component_v_button, {
                        key: 0,
                        variant: "link-secondary",
                        class: "w-auto",
                        "aria-label": _ctx.$t('Mis datos personales'),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalToShow = 'the-patient-personal-data-modal'))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Mis datos personales')), 1)
                        ]),
                        _: 1
                      }, 8, ["aria-label"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Protocolo:')) + " ", 1),
                      (_ctx.currentTreatment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(_component_v_protocol_name, {
                              text: _ctx.protocolName(),
                              color: _ctx.protocolType()
                            }, null, 8, ["text", "color"]),
                            (_ctx.currentTreatment.status === 'finalized')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('(Finalizado)')), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('- Sin datos -')), 1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Fase:')) + " ", 1),
                      (_ctx.currentTreatment)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                            _createTextVNode(_toDisplayString(_ctx.phaseActive().protocolPhase.name) + " ", 1),
                            _createElementVNode("a", {
                              target: "_blank",
                              href: _ctx.getProtocolPhaseUrl(),
                              "aria-label": _ctx.$t('Ver'),
                              title: _ctx.$t('Ver')
                            }, _hoisted_25, 8, _hoisted_23),
                            _createElementVNode("span", {
                              class: "icon icon-import fw-bold me-8 clickable",
                              "aria-hidden": "true",
                              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadProtocolPhase && _ctx.downloadProtocolPhase(...args)))
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('- Sin datos -')), 1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("p", _hoisted_28, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Fecha de inicio:')) + " ", 1),
                      _createElementVNode("span", _hoisted_29, _toDisplayString(!_ctx.currentTreatment ? _ctx.$t('- Sin datos -') : _ctx.$str.formatDate(_ctx.phaseActive().initDate)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.$t('Última consulta:')) + " ", 1),
                      _createElementVNode("span", _hoisted_32, _toDisplayString(!_ctx.lastConsultation ? _ctx.$t('- Sin datos -') : _ctx.$str.formatDate(_ctx.lastConsultation.initDate)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('GRPD:')), 1),
                      (!!_ctx.currentExpedient.rgpdConfirmedAt)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.$t('Válido')), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(_ctx.$t('Sin aceptar')), 1))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("ul", _hoisted_39, [
              _createElementVNode("li", _hoisted_40, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('general')}]),
                  "aria-label": _ctx.$t('General'),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeExpedientSection('general')))
                }, _toDisplayString(_ctx.$t('General')), 11, _hoisted_41)
              ]),
              (_ctx.can('professional.expedient.form.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('datos-medicos')}]),
                      "aria-label": _ctx.$t('Datos médicos'),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeExpedientSection('datos-medicos')))
                    }, _toDisplayString(_ctx.$t('Datos médicos')), 11, _hoisted_43)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('patient.consultation.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('consultas')}]),
                      "aria-label": _ctx.$t('Consultas'),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeExpedientSection('consultas')))
                    }, _toDisplayString(_ctx.$t('Consultas')), 11, _hoisted_45)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('patient.expedient.purchase-authorization.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", {'router-link-active router-link-exact-active': _ctx.isActive('autorizacion-compra')}]),
                      "aria-label": _ctx.$t('Autorización de compra'),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeExpedientSection('autorizacion-compra')))
                    }, _toDisplayString(_ctx.$t('Autorización de compra')), 11, _hoisted_47)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.can('patient.expedient.file.index'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", { 'router-link-active router-link-exact-active': _ctx.isActive('documentos')}]),
                      "aria-label": _ctx.$t('Documentos'),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeExpedientSection('documentos')))
                    }, _toDisplayString(_ctx.$t('Documentos')), 11, _hoisted_49)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", {
                id: "general",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('general') }])
              }, [
                (_ctx.isActive('general'))
                  ? (_openBlock(), _createBlock(_component_the_patient_expedient_file_general, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "medicalData",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('datos-medicos') }])
              }, [
                (_ctx.isActive('datos-medicos'))
                  ? (_openBlock(), _createBlock(_component_the_professional_expedient_file_medical_data, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "consultations",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('consultas') }])
              }, [
                (_ctx.isActive('consultas'))
                  ? (_openBlock(), _createBlock(_component_the_patient_consultation, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "purchaseAuthorization",
                class: _normalizeClass(["tab-pane fade py-32", {'active show': _ctx.isActive('autorizacion-compra') }])
              }, [
                (_ctx.isActive('autorizacion-compra'))
                  ? (_openBlock(), _createBlock(_component_the_patient_purchase_authorization_list, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                id: "documents",
                class: _normalizeClass(["tab-pane fade py-32", { 'active show': _ctx.isActive('documentos') }])
              }, [
                (_ctx.isActive('documentos'))
                  ? (_openBlock(), _createBlock(_component_the_patient_document, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.modalToShow === 'the-patient-personal-data-modal')
      ? (_openBlock(), _createBlock(_component_the_patient_personal_data_modal, {
          key: 2,
          patient: _ctx.currentExpedient.patient,
          onClosed: _cache[7] || (_cache[7] = ($event: any) => (_ctx.modalToShow = null))
        }, null, 8, ["patient"]))
      : _createCommentVNode("", true),
    (_ctx.currentExpedient && _ctx.currentExpedient.patient
  && _ctx.status === 'loaded' && _ctx.currentRoom)
      ? (_openBlock(), _createBlock(_component_the_patient_video_call_overlay, { key: 3 }))
      : _createCommentVNode("", true)
  ], 64))
}